module.exports = __webpack_public_path__ + "img/ics_o_cod_rej.82bc45c5.svg";